export default __webpack_public_path__ + "media/music/b293512308643f919d2e9c3af641f554.mp3";